import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, TableBodySkeleton } from '../../common/components';

// Componentes separados
import ActiveContractsDataTable from './components/ActiveContractsDataTable';
import MoraContractsDataTable from './components/MoraContractsDataTable';
import ArchivedContractsDataTable from './components/ArchivedContractsDataTable';
import ContractEditDialog from './components/ContractEditDialog';

// Hook personalizado
import { useContractsTable } from './hooks/useContractsTable';

/**
 * Componente principal de la tabla de contratos
 * Refactorizado para seguir los patrones del proyecto con TanStack Query
 */
const ContractsTable = () => {
  // Hook personalizado que maneja toda la lógica
  const {
    // Estados de datos
    contractsCount,
    moraContractsCount,
    archivedContractsCount,
    isLoading,

    // Estados de diálogo
    dialogOpen,
    contractFilters,
    isArchiveDialog,

    // Datos de soporte
    plans,
    groups,

    // Funciones de manejo
    handleOpenActiveDialog,
    handleOpenArchivedDialog,
    handleOpenMoraDialog,
    handleCloseDialog,
    handleEditContracts,

    // Control de refrescos
    save,
    setSave,
  } = useContractsTable();

  return (
    <>
      <Box>
        <Box>
          <FormTitleBox title="Contratos" />
          <ActiveContractsDataTable
            contractsCount={contractsCount}
            plans={plans}
            groups={groups}
            onEditContracts={handleEditContracts}
            onOpenDialog={handleOpenActiveDialog}
            isLoading={isLoading}
            LoadingComponent={TableBodySkeleton}
          />
        </Box>

        <Box sx={{ mt: 1 }}>
          <FormTitleBox title="Cartera en mora - Viviendas sin casa" />
          <MoraContractsDataTable
            moraContractsCount={moraContractsCount}
            plans={plans}
            groups={groups}
            onEditContracts={handleEditContracts}
            onOpenDialog={handleOpenMoraDialog}
            isLoading={isLoading}
            LoadingComponent={TableBodySkeleton}
          />
        </Box>

        <Box sx={{ mt: 1 }}>
          <FormTitleBox title="Contratos Archivados" />
          <ArchivedContractsDataTable
            archivedContractsCount={archivedContractsCount}
            plans={plans}
            groups={groups}
            onEditContracts={handleEditContracts}
            onOpenDialog={handleOpenArchivedDialog}
            isLoading={isLoading}
            LoadingComponent={TableBodySkeleton}
          />
        </Box>
      </Box>

      <ContractEditDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        contractFilters={contractFilters}
        isArchiveDialog={isArchiveDialog}
        save={save}
        setSave={setSave}
      />
    </>
  );
};

export default ContractsTable;
